<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >ข้อมูลยื่นคำร้อง</router-link
              >
            </li>
            <li class="breadcrumb-item" aria-current="page">
              <router-link
                class="text-decoration-none router-link"
                to="/AgentInfo"
                >ขอเปลี่ยนแปลงข้อมูลตัวแทน</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ขอเปลี่ยนแปลงที่อยู่
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/AgentInfo">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ขอเปลี่ยนแปลงที่อยู่
        </div>
      </div>

      <div class="col font-family">
        <div v-if="this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS.length > 0">
          <div class="border-bottom">
            <div class="d-flex align-items-center mt-4 position-relative ">
              <div class="icon-address mb-1">
                <img src="@/assets/images/icon-home.svg" class="w-100" />
              </div>
              <div class="blue-1 fw-normal fs-4 d-lg-inline-block ps-2 mt-2">
                ที่อยู่ติดต่อ
              </div>
              <div v-if="this.$store.state.AddressHome !== ''">
                <img src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <router-link to="/EditAddress" class="icon-circle bg-blue-2" @click="SetEditAddress('H')">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
            <div class="gray-3 mb-2 mt-2 ps-2">
              <div v-if="this.$store.state.AddressHome !== ''">
                <label class="fs-5">{{ this.$store.state.AddressHome }}</label><br />
                <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.AddressHomeTele }}</label>
              </div>
              <div v-else>
                <div v-for="(address, index) in this.$store.state.AgentInfo.ADDRESS" :key="index">
                  <div v-if="address.ADR_TYPE == 'H'" >
                    <label class="fs-5">{{ address.ADDRESS }}</label> <label style="font-family: monospace; font-size: 13px;">{{ address.POST }}</label><br />
                    <label style="font-family: monospace; font-size: 13px;">{{ address.TELEPHONE }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="border-bottom">
            <div class="d-flex align-items-center mt-4 position-relative">
              <div class="icon-address mb-1">
                <img src="@/assets/images/icon-home.svg" class="w-100" />
              </div>
              <div class="blue-1 fw-normal fs-4 d-lg-inline-block ps-2 mt-2">
                ที่อยู่ทะเบียนบ้าน
              </div>
              <div v-if="this.$store.state.AddressCont !== ''">
                <img src="@/assets/images/checked.svg" class="svg-checked" />
              </div>
              <router-link to="/EditAddress" class="icon-circle bg-blue-2" @click="SetEditAddress('T')">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
            <div class="gray-3 mb-2 mt-2 ps-2">
              <div v-if="this.$store.state.AddressCont !== ''">
                <label class="fs-5">{{ this.$store.state.AddressCont }}</label><br />
                <label style="font-family: monospace; font-size: 13px;">{{ this.$store.state.AddressContTele }}</label>
              </div>
              <div v-else>
                <div v-for="(address, index) in this.$store.state.AgentInfo.ADDRESS" :key="index">
                  <div v-if="address.ADR_TYPE == 'T'" >
                    <label class="fs-5">{{ address.ADDRESS }}</label> <label style="font-family: monospace; font-size: 13px;">{{ address.POST }}</label><br />
                    <label style="font-family: monospace; font-size: 13px;">{{ address.TELEPHONE }}</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="border-bottom">
            <div class="d-flex align-items-center mt-4 position-relative ">
              <div class="icon-address mb-1">
                <img src="@/assets/images/icon-home.svg" class="w-100" />
              </div>
              <div class="blue-1 fw-normal fs-4 d-lg-inline-block ps-2 mt-2">
                ที่อยู่ติดต่อ
              </div>
              <router-link to="/EditAddress" class="icon-circle bg-blue-2" @click="SetEditAddress('H')">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
            <div class="gray-3 mb-2 mt-2 ps-2">
              <div v-for="(address, index) in this.$store.state.AgentInfo.ADDRESS" :key="index">
                <div v-if="address.ADR_TYPE == 'H'">
                  <label class="fs-5">{{ address.ADDRESS }}</label> <label style="font-family: monospace; font-size: 13px;"> {{ address.POST }}</label><br />
                  <label style="font-family: monospace; font-size: 13px;">{{ address.TELEPHONE }}</label>
                </div>
              </div>
            </div>
          </div>
          <div class="border-bottom">
            <div class="d-flex align-items-center mt-4 position-relative ">
              <div class="icon-address mb-1">
                <img src="@/assets/images/icon-home.svg" class="w-100" />
              </div>
              <div class="blue-1 fw-normal fs-4 d-lg-inline-block ps-2 mt-2">
                ที่อยู่ทะเบียนบ้าน
              </div>
              <router-link to="/EditAddress" class="icon-circle bg-blue-2" @click="SetEditAddress('T')">
                <img src="@/assets/images/icon-pencil.svg" class="w-100 p-2" />
              </router-link>
            </div>
            <div class="gray-3 mb-2 mt-2 ps-2">
              <div v-for="(address, index) in this.$store.state.AgentInfo.ADDRESS" :key="index">
                <div v-if="address.ADR_TYPE == 'T'" >
                  <label class="fs-5">{{ address.ADDRESS }}</label> <label style="font-family: monospace; font-size: 13px;">{{ address.POST }}</label><br />
                  <label style="font-family: monospace; font-size: 13px;">{{ address.TELEPHONE }}</label>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <router-link to="/AgentInfo">
              <button
                type="button"
                class="btn btn-continue font-family d-inline-block"
                @click="EnterNext()"
              >
                ดำเนินการต่อ
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light fw-normal popup_cancel"
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <router-link to="/AgentInfo">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
export default {
  name: "AgentAddress",
  components: {
    Menu,
  },
  mounted() {
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
  },
  methods: {
    EnterNext() {

    },
    SetEditAddress(Type){
      this.$store.state.TypeAddressE = Type;
    },
    ClearData() {
      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.ADDRESS = [];
      this.$store.state.AddressHome = '';
      this.$store.state.AddressHomeTele = '';
      this.$store.state.AddressRegis = '';
      this.$store.state.AddressRegisTele = '';
      this.$store.state.EditAgentInfo.CHANGE_ADDRESS.SUCCESS = false;
    },
  },
};
</script>